<template>
  <div class="ProjectEvaluationList">
    <AppHeader content="能力量表"></AppHeader>
    <AppBox class="appBox" id="appBox">
      <div class="tableFilter">
        <el-form :inline="true" size="small">
          <el-form-item label="时间">
            <date-select ref="dateSelector" @pick="dataPick"></date-select>
          </el-form-item>
          <el-form-item label="能力">
            <app-tree-select :options="tagTree"
                             :valueArr="formData.tagIds"
                             @check="handleTagSelect"></app-tree-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查找</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-row class="el-row-2">
        <el-col>
          <el-table class="report-table"
                    :data="data"
                    @sort-change="handleSortChange"
                    @row-click="handleClickRow"
                    style="width: 100%;cursor:pointer;">
            <el-table-column
                prop="username"
                label="用户名称">
            </el-table-column>
            <el-table-column v-for="item in tagList"
                             sortable="custom"
                             :sort-orders="['descending','ascending']"
                             :sort-by="['data.'+item.tagId]"
                             :label="item.tagName">
              <template slot-scope="scope">
                <div>{{ scope.row.data[item.tagId] ? scope.row.data[item.tagId].toFixed(1) : "-" }}</div>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <UserEvaluationModal ref="userEvaluationModal"></UserEvaluationModal>
    </AppBox>
  </div>
</template>

<script>
import AppHeader from "@/components/ui/AppHeader/index.vue";
import AppBox from "@/components/ui/AppBox/index.vue";
import {mapActions, mapState} from "vuex";
import Base64 from "@/utils/base64";
import DateSelect from "@/components/dateSelect/index.vue";
import extend from "@/components/ui/AppTable/extend";
import UserEvaluationModal from "@/pages/ProjectManagement/UserEvaluationModal.vue";
import AppTreeSelect from "@/components/ui/AppTreeSelect/index.vue";

export default {
  name: "ProjectEvaluationList",
  components: {AppTreeSelect, UserEvaluationModal, extend, DateSelect, AppHeader, AppBox},
  data() {
    return {
      formData: {
        tagIds: []
      },
      tagTree: [],
      data: [],
      tagList: {},
      dateRange: null,
    };
  },
  computed: {
    ...mapState("courseCenter", ["tagCategoryList"]),
  },
  async mounted() {
    await this.getTagCategoryList({
      includeChild: true,
      page: 1,
      size: 10000,
    });
    this.tagTree = this.tagCategoryList.data;
    this.formData.projectId = Base64.decode(this.$route.params.projectId);
    this.$refs.dateSelector.dateRange = this.dateRange;
    let item = localStorage.getItem("evaluationList" + this.formData.projectId);
    if (item) {
      this.formData.tagIds = JSON.parse(item);
    }
    await this.loadData();
  },
  methods: {
    ...mapActions("projectCenter", ["getProjectUserList"]),
    ...mapActions("courseCenter", ["getTagCategoryList"]),
    handleTagSelect(click, data) {
      this.formData.tagIds = data.checkedKeys
    },
    onReset() {
      this.dateRange = null;
      this.formData.tagIds = [];
    },
    onSubmit() {
      this.loadData();
    },
    handleClickRow(row) {
      this.$refs.userEvaluationModal.visible = true;
      this.$refs.userEvaluationModal.initData(this.tagList, row);
    },
    handleSortChange(sort) {
      let order = sort.order;
      let sortKey = sort.column.sortBy[0];
      let direct;
      if (order === "ascending")
        direct = 1;
      else if (order === "descending")
        direct = -1;
      else
        return;
      let split = sortKey.split(".");
      this.data = this.data.sort((a, b) => {
        split.forEach(item => {
          a = a[item];
          b = b[item];
        })
        if (!a && b) return 1;
        if (!b && a) return -1;
        if (!a && !b) return 0;
        return (a - b) * direct;
      });
    },
    async loadData() {
      if (this.dateRange) {
        this.formData.startTime = this.dateRange[0];
        this.formData.endTime = this.dateRange[1];
      } else {
        this.formData.startTime = this.formData.endTime = null;
      }
      let newVar = await this.getProjectUserList(this.formData);
      this.data = newVar.data.userEvaluations;
      this.tagList = newVar.data.tagInfoList;
      this.formData.tagIds = this.tagList.map(item => item.tagId);
      localStorage.setItem("evaluationList" + this.formData.projectId, JSON.stringify(this.formData.tagIds))
    },
    dataPick(dateRange) {
      this.dateRange = dateRange;
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
.ProjectEvaluationList {

  .appBox {
    height: calc(100vh - 155px);
    min-height: 330px;
    overflow-y: auto;

    .tableFilter {
    }

    .el-row-2 {
      padding: 1rem 0;
    }

    .report-table {
      overflow-y: auto;
      height: 65vh;
    }
  }
}
</style>
